import $ from '../utils/jquery';

// Load slick as a script that attaches to global jQuery (avoids CommonJS bundling issues)
const loadSlick = () => {
	return new Promise((resolve) => {
		if ($.fn.slick) {
			resolve();
			return;
		}
		const script = document.createElement('script');
		script.src = '/wp-content/themes/sao-2026/assets/scripts/slick.min.js';
		script.onload = resolve;
		document.head.appendChild(script);
	});
};

const bindOne = ($block) => {
	const $track = $block.find('.quote-carousel__track');
	const $prev = $block.find('.quote-carousel__nav--prev');
	const $next = $block.find('.quote-carousel__nav--next');

	if (!$track.length || $track.hasClass('slick-initialized')) {
		return;
	}

	$track.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		speed: 400,
		arrows: true,
		dots: false,
		infinite: false,
		adaptiveHeight: true,
		prevArrow: $prev,
		nextArrow: $next,
	});

	const updateDisabled = (slick, current) => {
		$prev.prop('disabled', current === 0);
		$next.prop('disabled', current === slick.slideCount - 1);
	};

	updateDisabled($track.slick('getSlick'), 0);

	$track.on('afterChange', function (e, slick, currentSlide) {
		updateDisabled(slick, currentSlide);
	});
};

const bind = () => {
	$('.wp-block-acf-quote-carousel').each(function () {
		bindOne($(this));
	});
};

export default async () => {
	const $blocks = $('.wp-block-acf-quote-carousel');
	if (!$blocks.length) {
		return;
	}

	await loadSlick();
	bind();
};
